import { render, staticRenderFns } from "./MensagemAnexo.vue?vue&type=template&id=3d6e1cc6"
import script from "./MensagemAnexo.vue?vue&type=script&lang=js"
export * from "./MensagemAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {
  VAlert,
})
